<template>
  <v-btn
    icon class="mt-0"
    v-if="isFavorite"
    @click.stop="removeFavorite(item)"
    color="white"
  >
    <v-icon color="red">favorite</v-icon>
  </v-btn>

  <v-btn
    icon class="mt-0"
    v-else-if="!isFavorite && authUser.id && authUser.is_employee"
    @click.stop="addFavorite(item)"
    color="white"
  >
    <v-icon color="red">favorite_border</v-icon>
  </v-btn>

  <v-btn
    icon class="mt-0"
    v-else-if="authUser.id && !authUser.is_employee"
    @click.stop="showOnlyForEmployeesDialog()"
    color="white"
  >
    <v-icon color="red">favorite_border</v-icon>
  </v-btn>

  <v-btn
    icon class="mt-0"
    v-else
    @click.stop="showRegistrationRequiredDialog()"
    color="white"
  >
    <v-icon color="red">favorite_border</v-icon>
  </v-btn>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

const { mapState: mapUserState, mapActions: mapUserActions } = createNamespacedHelpers('user');

export default {
  name: 'FavoriteButton',
  props: {
    item: {
      type: Object,
    },
    light: {
      type: Boolean,
    },
  },
  computed: {
    ...mapUserState([
      'authUser',
      'favorites',
    ]),
    isFavorite() {
      if (this.item) {
        const isInFavorites = this.favorites.find((favorite) => favorite.id === this.item.id);
        return !!isInFavorites;
      }
      return false;
    },
  },
  methods: {
    ...mapUserActions([
      'addFavorite',
      'removeFavorite',
    ]),
    showRegistrationRequiredDialog() {
      this.$eventBus.$emit('show-user-registration-required-dialog');
    },
    showOnlyForEmployeesDialog() {
      this.$eventBus.$emit('show-only-for-employee-dialog');
    },
  },
};
</script>
